import React, { useMemo, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import bcrypt from "bcryptjs";
import { setSession, getSessionMinutesFromEnv } from "./session";
import "./login.css";

const Login = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const redirectTo = location.state?.from?.pathname || "/admin";

    const [user, setUser] = useState("");
    const [pass, setPass] = useState("");
    const [err, setErr] = useState("");

    const envUser = useMemo(
        () => (process.env.REACT_APP_ADMIN_USER || "admin").trim(),
        []
    );

    const envHash = useMemo(() => {
        const raw = (process.env.REACT_APP_ADMIN_PASS_HASH || "").trim();
        return raw
            .replace(/^['"]|['"]$/g, "")  // срежем внешние кавычки, если есть
            .replace(/\\\$/g, "$")        // превратим "\$" обратно в "$"
            .replace(/\\/g, "");          // удалим любые оставшиеся обратные слеши
    }, []);

    // Временный fallback: открытый пароль из .env (только для dev)
    const envPlain = useMemo(
        () => (process.env.REACT_APP_ADMIN_PASS || "").trim(),
        []
    );

    const sessionMinutes = useMemo(() => getSessionMinutesFromEnv(), []);

    useEffect(() => {
        // Диагностика: можно удалить после успешного входа
        console.log("ENV user =", envUser);
        console.log("ENV hash len =", (envHash || "").length);
        console.log("ENV hash start =", (envHash || "").slice(0, 4));
        console.log("ENV hash end =", (envHash || "").slice(-4));
    }, [envUser, envHash]);

    const onSubmit = (e) => {
        e.preventDefault();
        setErr("");

        const login = user.trim(); // логин без пробелов по краям

        if (login !== envUser) {
            setErr("Неверный логин или пароль.");
            return;
        }

        let ok = false;

        // 1) Пытаемся сравнить с хэшем (основной путь)
        if (envHash && envHash.startsWith("$2")) {
            try {
                ok = bcrypt.compareSync(pass, envHash);
            } catch {
                // если формат хэша кривой — просто не засчитываем
                ok = false;
            }
        }

        // 2) Если хэш не прошёл — пробуем fallback по открытому паролю (dev-only)
        if (!ok && envPlain) {
            ok = pass === envPlain; // здесь можно .trim() добавить, если нужно
        }

        if (!ok) {
            setErr("Неверный логин или пароль.");
            return;
        }

        setSession(sessionMinutes);
        navigate(redirectTo, { replace: true });
    };

    return (
        <div className="admin-login-wrap">
            <form className="admin-login-card" onSubmit={onSubmit}>
                <h1>Админ-панель</h1>
                <label>
                    Логин
                    <input
                        type="text"
                        value={user}
                        onChange={(e) => setUser(e.target.value)}
                        placeholder="admin"
                        autoFocus
                        required
                    />
                </label>
                <label>
                    Пароль
                    <input
                        type="password"
                        value={pass}
                        onChange={(e) => setPass(e.target.value)}
                        placeholder="••••••••"
                        required
                    />
                </label>

                {err && <div className="error">{err}</div>}

                <button type="submit">Войти</button>
                <p className="hint">Сессия истечёт автоматически через {sessionMinutes} мин.</p>
            </form>
        </div>
    );
};

export default Login;
